/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionsContainer_local = {
    readonly accessToken: string | null;
    readonly " $refType": "ModerationActionsContainer_local";
};
export type ModerationActionsContainer_local$data = ModerationActionsContainer_local;
export type ModerationActionsContainer_local$key = {
    readonly " $data"?: ModerationActionsContainer_local$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_local">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionsContainer_local",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'cf0607d282c73295146258a590a0d845';
export default node;
